import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import PoseCard from './PoseCard';
import style from './MovePoses.module.sass';

const PosePanel = ({ droppableId, title, subtitle, poses, selectedPoseId, onSelectPose }) => {
  return (
    <div className={style.panel}>
      <div className={style.panelHeader}>
        <h4>{title}</h4>
        {subtitle && <div className={style.panelSubtitle}>{subtitle}</div>}
      </div>
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`${style.dropZone} ${snapshot.isDraggingOver ? style.dragOver : ''}`}
          >
            {poses.length === 0 ? (
              <div className={style.emptyState}>No poses</div>
            ) : (
              poses.map((pose, index) => (
                <PoseCard
                  key={pose.id}
                  pose={pose}
                  index={index}
                  isSelected={selectedPoseId === pose.id}
                  onSelect={onSelectPose}
                />
              ))
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default PosePanel;
